import * as React from "react";
import "../Styles/style.css";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import axios from "axios";
import { baseUrl } from "../../api/ipconfig";

const FeatureAd = ({ open, onClose, response }) => {
  const [packageIndex, setPackageIndex] = React.useState(3);
  const [price, setPrice] = React.useState(0);
  const [packages, setPackages] = React.useState([]);

  const fetchPackages = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${baseUrl}/featuredaddpricing `, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPackages(response?.data?.featured_pricning);
    } catch (error) {
      console.error("Error fetching packages", error);
    }
  };
  React.useEffect(() => {
    fetchPackages();
  }, []);

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableAutoFocus={true}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="Fw-popups"
    >
      <Box className="md-modal position-relative p-3 p-md-4">
        <div className="text-center"></div>
        <>
          <h5 className="mt-3 text-black fw-600 text-center">
            Want to Sell Your Car Faster?
          </h5>

          <div className="row d-flex justify-content-center align-items-center mt-3">
            <div className="col-lg-2">
              <img
                src="https://wsa3.pakwheels.com/assets/get-featured-car-e4cd11ec4696af67a5d5c4b4288fec64.svg"
                alt="feature-img"
              />
            </div>

            <div className="col-lg-6">
              <div className="d-flex gap-3 align-items-center">
                <i className="fa-solid fa-check text-success"></i>
                <span className="fontSm">
                  Reach up to 10x times more buyers
                </span>
              </div>

              <div className="d-flex gap-3 align-items-center my-2">
                <i className="fa-solid fa-check text-success"></i>
                <span className="fontSm">Show your Ad in top position</span>
              </div>

              <div className="d-flex gap-3 align-items-center">
                <i className="fa-solid fa-check text-success"></i>
                <span className="fontSm">
                  Get noticed with a Feature Ad tag
                </span>
              </div>
            </div>
          </div>

          {packages &&
            packages.map((data) => (
              <label
                key={data?.featureaddpricing_id}
                id="singleCar"
                className={`w-100 ${
                  packageIndex === data?.featureaddpricing_id
                    ? "bgLightRed border border-danger"
                    : "border border-black-50"
                } p-3 rounded mt-3 `}
                onClick={() => {
                  setPackageIndex(data?.featureaddpricing_id);
                  setPrice(data?.featureaddpricing_price);
                }}
              >
                <div className="d-flex justify-content-between">
                  <div className="mb-3">
                    <div className="d-flex gap-3">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="singleCar"
                        name="car"
                        defaultChecked={
                          packageIndex === data?.featureaddpricing_id
                            ? true
                            : false
                        }
                      />

                      <div className="d-flex gap-3">
                        <h5 className="text-black fs-5 text-capitalize">
                          {data?.featureaddpricing_days}
                        </h5>
                        {data?.featureaddpricing_id === 3 && (
                          <p className="contactSellerBtn text-white py-1 px-2 rounded">
                            Recommended
                          </p>
                        )}
                      </div>
                    </div>
                    <p className="text-black-50 fontSm m-0 p-0">
                      {data?.featureaddpricing_description}
                    </p>
                  </div>

                  <p className="text-black fw-600">
                    PKR {data?.featureaddpricing_price}
                  </p>
                </div>
              </label>
            ))}

          <div className="d-flex justify-content-center mt-3">
            <Button variant="contained" className="bgSecondary">
              Proceed To Checkout
            </Button>
          </div>
        </>
      </Box>
    </Modal>
  );
};

export default FeatureAd;
